import {
  emailVerificationSitePath,
  entryQuestionnairePath,
  fastTrackPath,
  quickEnroll,
  rescheduleAppointmentPath,
  selfDeactivationVerificationSitePath,
  voucherUploadSitePath,
} from '@web/common';

export enum Routes {
  Root = '/',
  Faq = '/faq',
  EntryQuestionnaire = `/${entryQuestionnairePath}`,
  Register = '/register',
  NotEligible = '/not-eligible',
  Enroll = `/enroll`,
  QuickEnroll = `/${quickEnroll}`,
  Study = '/study',
  StammdatenQuestionnaire = 'stammdaten-questionnaire',
  CannabisConsumptionQuestionnaire = 'cannabis-consumption-questionnaire',
  RepeatedCannabisConsumptionQuestionnaire = 'repeated-cannabis-consumption-questionnaire',
  SF12Questionnaire = 'sf12-questionnaire',
  RepeatedSF12Questionnaire = 'repeated-sf12-questionnaire',
  BookInPerson = 'book-in-person',
  RescheduleAppointment = rescheduleAppointmentPath,
  Deactivated = 'deactivated',
  SelfDeactivation = 'self-deactivation',
  Nutzungsbedingungen = '/nutzungsbedingungen',
  Impressum = '/impressum',
  Datenschutz = '/datenschutz',
  TestPage = '/test-page',
  VerifyEmail = `${emailVerificationSitePath}`,
  VerifyDeactivation = `${selfDeactivationVerificationSitePath}`,

  // participant
  Profile = 'profile',
  SimpleOnboardingChecklist = fastTrackPath,
  Shop = 'shop',
  Questionnaires = 'questionnaires',
  Versand = 'versand',
  ShopOrder = 'shop/order',

  Points = 'points',
  Raffles = 'raffles',
  ActiveRaffles = 'active-raffles',
  PastRaffles = 'past-raffles',
  FutureRaffles = 'future-raffles',

  // shop employee
  OpenShopOrders = 'open-orders',
  RaffleWinners = 'raffle-winners',

  // study owner
  PausedUsers = 'users-on-hold',
  Statistics = 'statistics',
  FilterUsers = 'filter-users',
  User = 'user',
  Inventory = 'inventory',
  Voucher = `${voucherUploadSitePath}`,
  UserDetailEntryQuestionnaire = 'view-entry-questionnaire',
  UserDetailStammdatenQuestionnaire = 'view-stammdaten-questionnaire',
  UserDetailCannabisConsumptionQuestionnaire = 'view-cannabis-consumption-questionnaire',
  UserDetailSF12Questionnaire = 'view-sf12-questionnaire',
}
